<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Transferencias</strong>
          </div>
          
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div style='text-align:justific' slot="header">
            <strong class="izquierda">Filtros del Informe</strong>
            <strong class="derecha">GARANTÍA</strong>
          </div>
          <b-row>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Ejecutivos', 'codejecutivo', 'datosFormulario')"
                label-for="codejecutivo"
              >
                <b-form-select
                  :options="valEjecutivos"
                  v-model="datosFormulario.codejecutivo"
                  :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codejecutivo }}</span>
              </b-form-group>
            </b-col>

            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Fecha de pago en adelante', 'fecpago', 'datosFormulario')"
                label-for="fecpago"
                :horizontal="false"
              >
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormulario.fecpago"
                    :disabled="campoBloqueado('fecpago', 'datosFormulario')"
                  ></datepicker>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.fecpago }}</span>
                </b-input-group>
              </b-form-group>
            </b-col>
            
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Solo Transferencias', 'transoli', 'datosFormulario')"
                label-for="transoli"
              >
                <b-form-select
                  :options="valTransferencias"
                  v-model="datosFormulario.transoli"
                  :disabled="campoBloqueado('transoli', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.transoli }}</span>
              </b-form-group>
            </b-col>

            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Solo Proceso Manual', 'prcmanual', 'datosFormulario')"
                label-for="prcmanual"
              >
                <b-form-select
                  :options="valProceso"
                  v-model="datosFormulario.prcmanual"
                  :disabled="campoBloqueado('prcmanual', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.prcmanual }}</span>
              </b-form-group>
            </b-col>
            <b-col lg="2"> 
              <b-form-group
                label="asdf"
                label-class="label-blanco"
              >
              <b-form-checkbox
                v-model="datosFormulario.ckfiniqsinsol"
                value="s"
                unchecked-value="n"
                @change="asgckfiniqsinsol"
                v-b-tooltip.hover title="Con finiquito vinculado y sin solicitud"
                >
                Finiquitos sin solicitud
              </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          
          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                  
                  <b-button variant="success" @click="valmarcados('A')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Solicitar Transferencia
                  </b-button>
                  <b-button variant="warning" @click="valmarcados('B')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Proceso Manual
                  </b-button>
                  <b-button variant="danger" @click="valmarcados('C')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Quitar Marca
                  </b-button>
                  <b-button class="bt_fecransferencia" variant="success" @click="valmarcados('D')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-edit"></i> Fecha Transferencia
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>
 
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Transferencias</strong>
          </div>
          <b-row>
            <b-col lg="4">
              <div>
                <b-alert variant="info" show>
                  Finiquitos con transferencia solicitada: <strong>{{datosFormulario.canttransfsol}}</strong>
                  <br>
                  Finiquitos pendientes de solicitar transferencia: <strong>{{datosFormulario.canttransfpen}}</strong>
                  <br>
                  Total finiquitos en este rango de fecha: <strong>{{datosFormulario.totaltrans}}</strong>
                </b-alert>
              </div>  
            </b-col>
            <b-col lg="2"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange"
                  >
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  >
                    <template slot-scope="scope">
                      <div v-if="title.prop == 'BENEFICIARIO'">  
                                 <el-button  type="text"  v-if="scope.row.TIENECUENTA > 0" @click="detalleCtaBeneficiario(scope.row.SNFBENEFICIARIO)"> {{scope.row.BENEFICIARIO}}</el-button>      
                      <el-button class="colorBenef"  type="text"  v-else @click="detalleCtaBeneficiario(scope.row.SNFBENEFICIARIO)"> {{scope.row.BENEFICIARIO}}</el-button>      
                      <!-- <p  class="colorBenef" v-else >{{scope.row[title.prop]}}</p> -->
                      </div> 
            
                      <p v-else-if="title.prop == 'MONTOFINIQUITO'">  
                                 <el-button type="text"  v-if="scope.row.PRCMANUAL == 'N' && scope.row.TRANSOLI == 'N'" @click="mostrarModalAnular1(scope.row.POLIZA,scope.row.SNFBENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOFINIQUITO}}</el-button>     
                                 <el-button type="text"  v-if="scope.row.PRCMANUAL == 'S' || scope.row.TRANSOLI == 'S'" @click="mostrarModalAnular2(scope.row.POLIZA,scope.row.SNFBENEFICIARIO,scope.row.FECPAGO)"> {{scope.row.MONTOFINIQUITO}}</el-button>             
                      <p v-else>{{scope.row[title.prop]}}</p> 
                       
                    </template>

                  </el-table-column> 

                  <el-table-column label="Observación" min-width="250px" align="left">
                    <template slot-scope="scope">
                      <el-tooltip
                          v-for="button in customButtonsForRowObs(scope.row)"
                          :key="button.id"
                          :content="button.tooltip"
                          placement="top">
                          <el-button
                            type="text"
                            @click="button.handler"
                          >
                            <i v-bind:class="button.icon"></i>
                            {{ button.name }}
                          </el-button>
                      </el-tooltip>
                      {{ scope.row.OBSERVACION }}
                    </template>
                  </el-table-column>

                  <el-table-column label="Finiquito" min-width="100px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="finiquitos(scope.row.POLIZA,scope.row)">Ver</el-button>   
                      
                    </template>
                  </el-table-column>

                  <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>

                  <el-table-column type="selection" width="35" reserve-selection><!-- reserve-selection -->
                    </el-table-column>

                    <el-table-column label="Gen. Finiquito" min-width="160px" align="center">
                    <template slot-scope="scope">
                      <el-button  type="text" @click="imprime_finiquitos(scope.row.POLIZA, scope.row.SNFBENEFICIARIO, scope.row.FECPAGO)"> <i class="fa fa-print"> </i> Gen. Finiquito
                      </el-button>   
                      
                    </template>
                  </el-table-column>

                  
                  
                </data-tables>
              </div>
            </b-col>
          </b-row>
          <p><b>Accesos rápidos :</b>   ** Click en Beneficiario muestra sus datos bancarios |   ** Click en Monto permite anular el pago.</p>
       
        </b-card>

      </b-col>
    </b-row>

    <!-- Trasferencia-->
    <b-modal
      title="Trasferencia"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalTransferencia"
      @ok="trasferencia"
      @cancel="modalTransferencia = false"
    >
      Se marcarán para transferencia todas las pólizas seleccionadas, ¿desea continuar?
    </b-modal>

    <!-- Proceso manual-->
    <b-modal
      title="Proceso Manual"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalManual"
      @ok="manual"
      @cancel="modalManual = false"
    >
      Se marcarán para proceso manual todas las pólizas seleccionadas, ¿desea continuar?
    </b-modal>

    <!-- Quitar Marca-->
    <b-modal
      title="Quitar Marca"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalQuitar"
      @ok="quitar"
      @cancel="modalQuitar = false"
    >
      <p>Se quitará la marca de proceso manual o transferencia para todas las pólizas seleccionadas, ¿desea continuar?</p>
      <br>
      <b-form-textarea 
        v-if="mostrarobs === true" 
        id="obs"
        v-model="datosFormulario.obsquitar"
        placeholder="Ingrese la observación"
        rows="3"
        max-rows="6"
      >
      </b-form-textarea>
    </b-modal>

    <b-modal
      title="Registrar Fecha de Transferencia"
      cancel-title="Cancelar"
      ok-title="Continuar"
      class="modal-success"
      v-model="modalModificar"
      @ok="fechatransferencia();"
      @cancel="modalModificar = false"
    >
      <b-input-group>
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <datepicker
            :language="es"
            format="dd/MM/yyyy"
            :use-utc="true"
            input-class="form-control"
            v-model="datosFormulario.hoy"
            :disabled="campoBloqueado('hoy', 'datosFormulario')"
          ></datepicker>
          <span class="error-validacion-campo">{{ mensajeValidacionCampo.hoy }}</span>
        </b-input-group>
        <br>
        Se registrará la "Fecha de Transferencia" de los registros marcados con la fecha de seleccionada.  
      </b-modal>

    <!-- Detalle finiquitos -->
    <b-modal
      size="lg"
      title="Finiquitos"
      cancel-title="Cerrar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalFiniquitos"
      @ok="guardarLinkContishare();"
      @cancel="modalFiniquitos = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataFiniquitos"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @select="handleSelectionChange2"
                  @select-all="selectAll"                  
                >
                  <el-table-column
                    v-for="title in titlesFiniquitos"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  
                  <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="verFiniquito(scope.row.LINK)">Ver</el-button>   
                  </template>
                  </el-table-column>

                  <el-table-column type="selection" width="35" reserve-selection>
                  </el-table-column>

                  <el-table-column label="" min-width="10px" align="center">
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

    <b-modal
      title="Observación"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalObservacion"
      @ok="guardarObservacion();"
     
    >
      <b-form-textarea
        id="obs"
        v-model="modalDataObservacion.OBSERVACION"
        placeholder="Ingrese la observación"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>

    <!-- Editar cuenta -->
    <b-modal
      size="lg"
      title="Modificar"
      cancel-title="Cancelar"
      ok-title="Guardar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalEditar"
      @ok="modificar"
      @cancel="modalEditar = false"
    >
      
      <b-row>
        <b-col sm="3">  
          <b-form-group
            label="Moneda">
              <b-form-select
              :options="valMonedas"
              v-model="datosCtaBeneficiario.moneda"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row >
        <b-col sm="5">  
          <b-form-group
            label="Banco">
              <b-form-select
              :options="valBancos"
              v-model="datosCtaBeneficiario.banco"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="3">  
          <b-form-group
            label="Tipo de Cuenta">
              <b-form-select
              :options="valCuentas"
              v-model="datosCtaBeneficiario.tipocuenta"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="4">  
          <b-form-group
            label="Cuenta">
              <b-form-input
                  id="cuenta"
                  type="text"
                  placeholder=""
                  v-model="datosCtaBeneficiario.cuenta"
                  @change="validarCampo('pkg_sinpp_ctactebene', 'cuenta', $event, 'datosModificacion')">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.cuenta }}
                </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">  
          <b-form-group
            label="Libre">
              <b-form-textarea
                id="libre"
                v-model="datosCtaBeneficiario.libre"
                placeholder=""
                rows="3"
              ></b-form-textarea>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.libre }}
                </span>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    
    
    
    <!-- Detalle Cuenta Beneficiario -->
    <b-modal
      size="lg"
      ok-only
      title="Detalle de Cuenta de Beneficiario"
      cancel-title="Cancelar"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalCtaBeneficiario"
      @ok="modalCtaBeneficiario = false"
      @cancel="modalCtaBeneficiario = false">
      
      <b-row>
        <b-col sm="3">  
          <b-form-group
            label="Moneda"
            label-for="moneda">
              <b-form-input
              size="sm"
              id="moneda"
              type="text"
              v-model="datosCtaBeneficiario.moneda"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row> 
        <b-col sm="5">  
          <b-form-group
            label="Banco"
            label-for="banco">
              <b-form-input
              size="sm"
              id="banco"
              type="text"
              v-model="datosCtaBeneficiario.banco"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="3">  
          <b-form-group
            label="Tipo de Cuenta"
            label-for="tipocuenta">
             <b-form-input
              size="sm"
              id="tipocuenta"
              type="text"
              v-model="datosCtaBeneficiario.tipocuenta"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">  
          <b-form-group
            label="Cuenta"
            label-for="cuenta">
             <b-form-input
              size="sm"
              id="cuenta"
              type="text"
              v-model="datosCtaBeneficiario.cuenta"
              :disabled="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">  
          <b-form-group
            label="Libre"
            label-for="libre">
               <b-form-textarea
                id="libre"
                v-model="datosCtaBeneficiario.libre"
                placeholder=""
                rows="3"
                :disabled="true"
              ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

     <!-- Anular Indemnización Tipo 1 (cuando la transferencia no ha sido solicitada)-->
    <b-modal
      title="Anular Indemnización"
      cancel-title="Salir sin Anular"
      ok-title="Anular Indemnización"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalAnular1"
      @ok="anular1(datosFormulario.polizaanu,datosFormulario.benefanu,datosFormulario.fecpago)"
      @cancel="modalAnular1 = false"
    ><p>Se anulará esta indemnización</p>
    </b-modal>

       <!-- Anular Indemnización Tipo 2 (cuando la transferencia ya fue solicitada)-->
    <b-modal
      title="Anular Indemnización con Transferencia Solicitada"
      cancel-title="Salir sin Anular"
      ok-title="Anular Indemnización"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalAnular2"
      @ok="anular2(datosFormulario.polizaanu,datosFormulario.benefanu,datosFormulario.fecpago)"
      @cancel="modalAnular2 = false"
    ><p>Se anulará esta indemnización con transferencia solicitada, avise a Tesorería</p>
    </b-modal>

    <b-modal
      title="Registrar Fecha de Transferencia"
      cancel-title="Cancelar"
      ok-title="Continuar"
      class="modal-success"
      v-model="modalModificar"
      @ok="fechatransferencia();"
      @cancel="modalModificar = false"
    >
      <b-input-group>
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <datepicker
            :language="es"
            format="dd/MM/yyyy"
            :use-utc="true"
            input-class="form-control"
            v-model="datosFormulario.hoy"
            :disabled="campoBloqueado('hoy', 'datosFormulario')"
          ></datepicker>
          <span class="error-validacion-campo">{{ mensajeValidacionCampo.hoy }}</span>
        </b-input-group>
        <br>
        Se registrará la "Fecha de Transferencia" de los registros marcados con la fecha de seleccionada.  
      </b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarTransferencias from "@/components/services/apiGarTransferencias";
import apiGarCtaCteBeneficiario from "@/components/services/apiGarCtaCteBeneficiario";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";
import apiActividades from '@/components/services/apiActividades';
import apiBaseCorredor from '@/components/services/apiBaseCorredor';

export default {
  name: "Transferencias-gar",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      exportar: false,
      tieneAcceso: true,
      mostrarobs: false,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      dataFiniquitos: [],
      nombreexcel: "Transferencias",
      titles: [
        {
          prop: "CORRE",
          label: "Correlativo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "AFIANZADO",
          label: "Afianzado",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario **",
          align: "left",
          minwidth: "400",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONTOFINIQUITO",
          label: "Monto del finiquito **",
          align: "right",
          minwidth: "160",
        },
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "TRANSOLI",
          label: "Transferencia",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "PRCMANUAL",
          label: "Proceso Manual",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "FESOLICI",
          label: "Fecha Ult. Modif.",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "USUSOLICI",
          label: "Usuario",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "FECPAGOCHAR",
          label: "Fecha de Pago",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "FESOLTESO",
          label: "Fecha Sol. Tesoreria",
          align: "center",
          minwidth: "120",
        }
      ],
      
      titlesFiniquitos: [
        {
          prop: "CSHTITULO",
          label: "Nombre Finiquito",
          align: "left",
          minwidth: "250",
        },        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'FESOLICI'){
                let elDate = new Date(row["FESOLICI"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      datosFormulario: {
        retdeuda: "",
        transoli: "",
        prcmanual: "",
        codejecutivo: "",
        fecpago: "",
        fecpagochar: "",
        canttransfsol: "",
        canttransfpen: "",
        totaltrans: "",
        obsquitar:"",
        benefanu:"",
        polizaanu:"",
        fecpagoanu:"",
        ckfiniqsinsol: "n"
      },

      datosCtaBeneficiario: {
        moneda:"",
        banco: "",
        tipocuenta: "",
        cuenta: "",
        libre: "",
        beneficiario: ""
        
      },

      valMonedas: [],
      valBancos: [],
      valCuentas: [],


      value: null,
      seleccionados:[],
      noseleccionables:[],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valEjecutivos: [],
      valRetenidas: [],
      valTransferencias: [],
      valProceso: [],
      
      multipleSelection: [],

      modalTransferencia: false,
      modalManual: false,
      modalQuitar: false,
      modalFiniquitos: false,
      modalObservacion: false,
      modalDataObservacion: "",
      modalModificar: false,
      modalCtaBeneficiario: false,
      modalAnular1: false,
      modalAnular2: false,
      modalEditar: false,
      tracheck: "s",
      
      multipleSelectionfin: [],
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "CORRE"
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {

    modificar(){
      this.$Progress.start();

      
      if (this.datosCtaBeneficiario.moneda == '$'){
        return apiGarCtaCteBeneficiario
        .modificarPeso(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosCtaBeneficiario.beneficiario,
          this.datosCtaBeneficiario.moneda,
          this.datosCtaBeneficiario.banco,
          this.datosCtaBeneficiario.cuenta,
          this.datosCtaBeneficiario.libre,
          this.datosCtaBeneficiario.tipocuenta
        )
        .then(response => {
          this.$Progress.finish();
            this.crearNotificacion(
                "Modificar",
                "Datos guardados.",
                "success"
              );
            this.buscar();
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else{
        return apiGarCtaCteBeneficiario
        .modificar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosCtaBeneficiario.beneficiario,
          this.datosCtaBeneficiario.moneda,
          this.datosCtaBeneficiario.libre
        )
        .then(response => {
          this.$Progress.finish();
            this.crearNotificacion(
                "Modificar",
                "Datos guardados.",
                "success"
              );
            this.buscar();
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

    }, 


    guardarObservacion(){
      apiGarTransferencias
          .guardar_observacion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.modalDataObservacion.POLIZA,
            this.modalDataObservacion.SNFBENEFICIARIO,
            this.modalDataObservacion.FECPAGO,
            this.modalDataObservacion.OBSERVACION
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Observación",
                "Observación guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    guardarLinkContishare(){

      apiGarTransferencias
          .guardar_link_contishare(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datalink.POLIZA,
            this.datalink.SNFBENEFICIARIO,
            this.datalink.FECPAGO,
            this.linkdoccontish,
            this.nomdoccontish
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Link Contishare",
                "Link de Contishare guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    customButtonsForRowObs(row) {
          var botones = new Array();
          
            var obj = new Object();
            obj.tooltip = "Modificar";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-pencil-square-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.modalDataObservacion = row;
                this.modalObservacion = true;  
            }
            botones.push(obj);
          return botones;
    },

    verFiniquito(link) {
      window.open(link, '_blank');
    },

    customButtonsForRow(row) {
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "PDF";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }
          
          return botones;

    },

    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    validaSeleccion(selection, row) {
    
        if (row["FESOLTESO"] == undefined && row["TRANSOLI"] == 'S')  {
          //  this.$refs.refTable1.$children[0].toggleRowSelection(row, false);
           this.crearNotificacion("Validación","Esta transferencia no ha sido solicitada a Tesorería","error");  
           return false;
        };
      
    },

    asgckfiniqsinsol(checked){

      if (checked == 's'){
      this.datosFormulario.transoli = 'N';
          this.datosFormulario.prcmanual= 'N';
      } else {
        this.datosFormulario.transoli = 0;
          this.datosFormulario.prcmanual= 0;
      }

      this.$Progress.start();
      this.data = [];
      
      return apiGarTransferencias
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.retdeuda,
          this.datosFormulario.transoli,
          this.datosFormulario.prcmanual,
          this.datosFormulario.codejecutivo,
          this.datosFormulario.fecpago,
          checked
        )
        .then((response) => {
          
          this.data = response.data.res1;
          
          var lista_data = response.data.res;
          //console.log (response.data.res1);
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.canttransfsol = lista_data[i]["CANTTRANSFSOL"];
              this.datosFormulario.canttransfpen = lista_data[i]["CANTTRANSFPEN"];
              this.datosFormulario.totaltrans = lista_data[i]["TOTALTRANS"];
          }
          
          this.pagina = this.paginaAnterior;
          
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
        
    },

    validaSeleccionAll(rows) {
   // console.log("prueba", rows);

    let v_seleccionables = rows.filter(function (el) { if (el.FESOLTESO != undefined)  return el; })
      
    let v_noseleccionables = rows.filter(function (el) { if (el.FESOLTESO == undefined && el.TRANSOLI == "S")  return el; })

      if (this.seleccionados.length<=0 ){ 
        
        this.seleccionados = v_seleccionables;
        v_seleccionables.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row, true);
        })

      } else {
        this.$refs.refTable1.$children[0].clearSelection();
        this.seleccionados=[]; 
      }

      if (this.noseleccionables.length<=0 ){ 
        
        this.noseleccionables = v_noseleccionables;
        v_noseleccionables.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row, false);

        })

      } else {
        this.$refs.refTable1.$children[0].clearSelection();
        this.noseleccionables=[]; 
      }
   
    },

    handleSelectionChange2(selection, row) {

      this.nomdoccontish = row.CSHTITULO;
      this.linkdoccontish = row.LINK;

      // this.link = row
      // debugger;
      if (selection.length > 1 ) {
            this.crearNotificacion("Error de sistema", "Solo se puede seleccionar un solo registro", "error");
            this.$refs.refTable3.$children[0].toggleRowSelection(row, false);
            return;
           }
    },

    selectAll(rows){
      this.$refs.refTable3.$children[0].clearSelection();
      return;
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
 
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
      return apiGarTransferencias
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          this.valEjecutivos = this.llenaArrayLista(response.data.ejecutivos, 'codejecutivo', 'des_ejecutivo', false);
          this.valRetenidas = this.llenaArrayLista(response.data.retdeuda, 'retdeuda', 'desc_retdeuda', false);
          this.valTransferencias = this.llenaArrayLista(response.data.transoli, 'transoli', 'desc_transoli', false);
          this.valProceso = this.llenaArrayLista(response.data.prcmanual, 'prcmanual', 'desc_prcmanual', false);

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.retdeuda = lista_data[i]["retdeuda"];
            this.datosFormulario.transoli = lista_data[i]["transoli"];
            this.datosFormulario.prcmanual = lista_data[i]["prcmanual"];
            this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
            this.datosFormulario.fecpago = lista_data[i]["fecpago"];
            this.datosFormulario.hoy = lista_data[i]["hoy"];
          }

          this.datosFormularioEstado = response.data.festado;

      
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      this.data = [];
      
      
      return apiGarTransferencias
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.retdeuda,
          this.datosFormulario.transoli,
          this.datosFormulario.prcmanual,
          this.datosFormulario.codejecutivo,
          this.datosFormulario.fecpago,
          'n'
        )
        .then((response) => {
          
          this.data = response.data.res1;
          
          var lista_data = response.data.res;
          //console.log (response.data.res1);
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.canttransfsol = lista_data[i]["CANTTRANSFSOL"];
              this.datosFormulario.canttransfpen = lista_data[i]["CANTTRANSFPEN"];
              this.datosFormulario.totaltrans = lista_data[i]["TOTALTRANS"];
          }
          
          this.pagina = this.paginaAnterior;
          
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    pre_insertar_ctabenef() {
      // this.exportar = false;
      // this.mensajeValidacionCampo = {};
      // // this.data = [];
      // // this.data2 = [];
      // this.value = null;

      this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;

      return apiGarCtaCteBeneficiario
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          // //Bloqueo usuario no valido
          // if (response.data.args_out.usuarioval == 's'){
          //   this.tieneAcceso = true;
          // }else{
          //   this.tieneAcceso = false;
          // }
          
          // var lista_data = response.data.res;
          // for(var i = 0; i < lista_data.length; i++){
          //     this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
          //     this.datosFormulario.codbeneficiario = "";
          //     this.datosFormulario.idnacion = "";
          //     this.datosFormulario.nombre = "";
          // }
         
          
          // this.datosFormularioEstado = response.data.festado;
          
          

          //Carga lista de monedas
          var tiposMonedas = new Array();
          var lista_tipos_monedas = response.data.monedas;
          for(var i = 0; i < lista_tipos_monedas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_monedas[i]["tmocodigo"];
              obj.text = lista_tipos_monedas[i]["tmonombre"];
              tiposMonedas.push(obj);
          }
          this.valMonedas = tiposMonedas;

          //Carga lista de bancos
          var tiposBancos = new Array();
          var lista_tipos_bancos = response.data.bancos;
          for(var i = 0; i < lista_tipos_bancos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_bancos[i]["bcocodigo"];
              obj.text = lista_tipos_bancos[i]["bconombre"];
              tiposBancos.push(obj);
          }
          this.valBancos = tiposBancos;

          //Carga lista de cuentas
          var tiposCuentas = new Array();
          var lista_tipos_cuentas = response.data.cuentas;
          for(var i = 0; i < lista_tipos_cuentas.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_cuentas[i]["codigo"];
              obj.text = lista_tipos_cuentas[i]["nombre"];
              tiposCuentas.push(obj);
          }
          this.valCuentas = tiposCuentas;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    detalleCtaBeneficiario(beneficiario){

      this.pre_insertar_ctabenef();
      apiGarCtaCteBeneficiario
          .recuperar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            beneficiario
          )
          .then(response => {
            this.datosCtaBeneficiario = response.data.res;

            // this.modalCtaBeneficiario = true;
            this.modalEditar = true;
            

            console.log(this.datosCtaBeneficiario);

            if (response.data.res.length > 0) { 
               
                this.datosCtaBeneficiario.beneficiario = response.data.res[0].BENEFICIARIO;
                this.datosCtaBeneficiario.moneda = response.data.res[0].CODMONEDA == undefined? '$': response.data.res[0].CODMONEDA;
                this.datosCtaBeneficiario.banco = response.data.res[0].CODBANCO;
                this.datosCtaBeneficiario.tipocuenta = response.data.res[0].CODTIPOCUENTA;
                this.datosCtaBeneficiario.cuenta = response.data.res[0].CUENTA;
                this.datosCtaBeneficiario.libre = response.data.res[0].LIBRE;
            }

            
          })
          .catch(error => {
            this.modalctaBeneficiario = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    mostrarModalAnular1(p_poliza, p_beneficiario, p_fecpago){
        this.datosFormulario.polizaanu = p_poliza;
        this.datosFormulario.benefanu = p_beneficiario;
        this.datosFormulario.fecpagoanu = p_fecpago;
        this.modalAnular1 = true;
    },

     anular1(p_poliza, p_beneficiario,  p_fecpago){

      apiGarTransferencias
          .anular(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_poliza,
            p_beneficiario,
            p_fecpago,
            'N'
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Anular Indemnización",
                "Se anuló indemnización",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    mostrarModalAnular2(p_poliza, p_beneficiario, p_fecpago){
        this.datosFormulario.polizaanu = p_poliza;
        this.datosFormulario.benefanu = p_beneficiario;
        this.datosFormulario.fecpagoanu = p_fecpago;
        this.modalAnular2 = true;
    },

    anular2(p_poliza, p_beneficiario,  p_fecpago){

        apiGarTransferencias
          .anular(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_poliza,
            p_beneficiario,
            p_fecpago,
            'S'
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Anular Indemnización",
                "Se anuló indemnización",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
             this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });

    },

    formatter(row, column) {
      if ((column.property == "FESOLICI") || (column.property == "FECPAGO") || (column.property == "FESOLTESO")
          && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      }
       else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Transferencias</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["CORRE"] == undefined){
          this.data[key]["CORRE"] = "";
        }
        if(this.data[key]["POLIZA"] == undefined){
          this.data[key]["POLIZA"] = "";
        }
        if(this.data[key]["ASEGURADO"] == undefined){
          this.data[key]["ASEGURADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["MONEDA"] == undefined){
          this.data[key]["MONEDA"] = "";
        }
        if(this.data[key]["MONTOFINIQUITO"] == undefined){
          this.data[key]["MONTOFINIQUITO"] = "";
        }
        if(this.data[key]["EJECUTIVO"] == undefined){
          this.data[key]["EJECUTIVO"] = "";
        }
        if(this.data[key]["TRANSOLI"] == undefined){
          this.data[key]["TRANSOLI"] = "";
        }
        if(this.data[key]["PRCMANUAL"] == undefined){this.data
          this.data[key]["PRCMANUAL"] = "";
        }
        if(this.data[key]["RETDEUDA"] == undefined){
          this.data[key]["RETDEUDA"] = "";
        }
        if(this.data[key]["FESOLICI"] == undefined){
          this.data[key]["FESOLICI"] = "";
        }
        if(this.data[key]["USUSOLICI"] == undefined){
          this.data[key]["USUSOLICI"] = "";
        }
        if(this.data[key]["OBSERVACION"] == undefined){
          this.data[key]["OBSERVACION"] = "";
        }

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["CORRE"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["POLIZA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONEDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTOFINIQUITO"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["TRANSOLI"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRCMANUAL"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["RETDEUDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FESOLICI"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["USUSOLICI"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["OBSERVACION"] + "</td>\n";
        cuerpo += "</tr>\n";
      }


      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    finiquitos(poliza, row){
      this.$Progress.start();
      return apiGarTransferencias
        .finiquitos(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          poliza
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataFiniquitos = response.data.res1;
          this.datalink = row;
          this.modalFiniquitos = true;
           
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    imprime_finiquitos(p_poliza, p_beneficiario, p_fepago){
      this.$Progress.start();
      return apiGarTransferencias
        .mail_finiquito(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_poliza,
          p_beneficiario,
          p_fepago
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },


    trasferencia(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

      var siniestrosMarcados = "";
      var index = 0;
      var tipo = "T";
      
   
      for (index = 0; index < marcados.length; ++index) {
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + 'S' + ',' + 'N' + ','  + 'a' + ';';
                            
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarTransferencias
          .transferir(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados,
            tipo
          )
          .then(response => {
            this.$Progress.finish();
            
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );

            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    manual(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

      var siniestrosMarcados = "";
      var index = 0;
      var tipo = "M";
      
      for (index = 0; index < marcados.length; ++index) {
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                               marcados[index]["FECPAGO"] + ',' + 'N' + ',' + 'S' + ',' + 'N' + ',' + 'a' + ';';                    
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarTransferencias
          .transferir(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados,
            tipo
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },
   
    quitar(){
      this.$Progress.start();
     
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

      var siniestrosMarcados = "";
      var index = 0;
      var tipo = "Q";
      
      for (index = 0; index < marcados.length; ++index) {
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + 'N' + ',' + 'N' + ',' + 'S' + ',' + this.datosFormulario.obsquitar + ';';                     
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarTransferencias
          .transferir(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados,
            tipo
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    valmarcados(p_opcion){
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }

       this.multipleSelection = marcados;
      if (this.multipleSelection.length > 0){
         if (p_opcion == 'A') {this.modalTransferencia = true}
         else if (p_opcion == 'B') {this.modalManual = true}
         else if (p_opcion == 'C') {

                    this.$Progress.start();
                    /* solo los marcados y filtrados */
                    var filtrados = this.$refs.refTable1.tableData;
                    const names = filtrados.map(el => el.CORRE);
                    var marcados = new Array();

                    for (var index = 0; index < this.multipleSelection.length; ++index) {
                        if (names.includes(this.multipleSelection[index]["CORRE"])){
                          marcados.push(this.multipleSelection[index]);
                        }
                    }
                    /* -- */
                    var siniestrosMarcados = "";
                    var index = 0;
                    
                    for (index = 0; index < marcados.length; ++index) {
                      siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                                            marcados[index]["FECPAGO"] + ',' + 'N' + ',' + 'N' + ',' + 'S' + ',' + 'a' + ';';
                    }
                    
                    if (siniestrosMarcados != ""){
                      siniestrosMarcados = siniestrosMarcados.slice(0, -1)
                      apiGarTransferencias
                        .valtransferir(
                          this.$session.get("mail"),
                          this.$session.get("usuarioInterno"),
                          siniestrosMarcados
                        )
                        .then(response => {
                          this.$Progress.finish();
                            response.data = this.keysMinuscula(response.data);
                      
                        //Dependiendo de la respuesta, presenta o no, campo para registrar observaciones
                        if (response.data.args_out.respuesta == "OK") {
                          this.datosFormularioobsquitar=="";
                          this.modalQuitar = true;
                          this.mostrarobs = true;
                        } else {
                          this.mostrarobs = false;
                          this.crearNotificacion(
                          response.data.festado.resultado.titulo,
                          response.data.festado.resultado.mensaje,
                          response.data.festado.resultado.estado);
                        }
                          
                        })
                        .catch(error => {
                          this.$Progress.finish();
                          this.crearNotificacion("Error de sistema", error, "error");
                          return;
                        });
                    }
                    this.$Progress.finish();
                  }
         else if (p_opcion == 'D') {this.modalModificar = true}
      }else{
        this.crearNotificacion(
                "Marcar",
                "No tiene registros seleccionados.",
                "error"
              );
      }      
    },

    fechatransferencia(){
       this.$Progress.start();

      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
       
      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + marcados[index]["TRANSOLI"] + ',' + marcados[index]["PRCMANUAL"] + ',' + 'a' + ';';
      }
      // console.log(siniestrosMarcados);
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarTransferencias
          .fechatransferencia(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.hoy,
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            
            this.crearNotificacion(
                   response.data.festado.resultado.titulo,
                   response.data.festado.resultado.mensaje,
                   response.data.festado.resultado.estado
                );

            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor];
            obj.text = data[i][texto];
          }
          arr.push(obj);
          
      }
      return arr;
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            // this.toggleSelection([lista[index]]);
        }
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.derecha   { float: right; color: #20a8d8;}
.izquierda { float: left;  }

.bt_fecransferencia{
  background-color: #8E44AD !important;
}
.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}
.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
.colorBenef {
  color: red;
}

.colorBenef :hover {
  color: rgba(255, 0, 0, 0.445);
}

.label-blanco{
  color: #fff;
}

</style>
